export default __webpack_public_path__ + "static/media/grocery.fe089bc3.svg";